import Autocomplete from 'common/components/autocomplete'

type Option = {
  value: string
  label: string
}

type Props = {
  onSearchContentValue: (value: string) => void
  options: Option[] | undefined
  placeholder?: string
  'aria-label'?: string
}

const FuturamaAutocomplete = ({
  onSearchContentValue,
  options,
  placeholder = 'Find content',
  'aria-label': ariaLabel,
}: Props) => {
  return (
    <Autocomplete
      className="w-60 ml-4"
      aria-label={ariaLabel}
      placeholder={placeholder}
      options={options}
      onSearch={onSearchContentValue}
      backspaceRemovesValue={true}
    />
  )
}

export default FuturamaAutocomplete
